import { render, staticRenderFns } from "./WhatsAppInfo.vue?vue&type=template&id=6d3f5f3b&"
var script = {}
import style0 from "./WhatsAppInfo.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports